import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "app/store";
import { actions as configActions } from "app/configSlice";
import { DialogType } from "app/types";
import { getAccountUsers } from "features/account/api";
import { uploadImageAsset } from "app/api";

export const useFetchUserData = () => {
  const dispatch = useDispatch<AppDispatch>();

  const handleFetchParentsUser = useCallback(
    async ({ uid, callback }: { uid: string; callback?: (redirectTo: string) => void }) => {
      try {
        await dispatch(getAccountUsers({ uid })).unwrap();
        if (callback) {
          callback("/parent");
        }
      } catch (error) {
        console.error(error);
        if (callback) {
          callback("/auth/login");
        }
      }
    },
    [dispatch],
  );

  const handleFetchUserData = useCallback(
    async (_params: { parent_uid: string; uid: string }) => {
      // Stub - not used in parents app directly
    },
    [],
  );

  return { handleFetchParentsUser, handleFetchUserData };
};

export const useDialog = () => {
  const dispatch = useDispatch<AppDispatch>();
  return useCallback(
    ({
      type,
      value,
      args,
    }: {
      type: DialogType;
      value: boolean;
      args?: { [key: string]: string };
    }) => {
      dispatch(
        configActions.updateDialog({
          type,
          value,
          args,
        }),
      );
    },
    [dispatch],
  );
};

// Image asset picker for child player icons
export const usePickImageAsset = () => {
  return async (
    file: File,
    uid: string,
    callback?: (asset: any) => void,
    fallback?: () => void,
  ) => {
    try {
      const response = await uploadImageAsset({
        uid,
        fileBlob: file,
        object_key: `user/${uid}/icon`,
        filename: file.name,
        tags: "icon",
        metadata: {},
        contentType: file.type,
      });
      if (callback) {
        callback(response.data.data);
      }
    } catch (error) {
      console.error(error);
      if (fallback) {
        fallback();
      }
    }
  };
};

// Image asset picker for parent icons
export const usePickParentImageAsset = () => {
  return async (
    file: File,
    uid: string,
    callback?: (asset: any) => void,
    fallback?: () => void,
  ) => {
    try {
      const response = await uploadImageAsset({
        uid,
        fileBlob: file,
        object_key: `parent/${uid}/icon`,
        filename: file.name,
        tags: "icon",
        metadata: {},
        contentType: file.type,
      });
      if (callback) {
        callback(response.data.data);
      }
    } catch (error) {
      console.error(error);
      if (fallback) {
        fallback();
      }
    }
  };
};
